// Angular
import { Component, OnInit } from "@angular/core";
// Models
import { ElasticService } from "./../../services/elastic";
import { ActivatedRoute } from "@angular/router";

import { Tournament } from "./../../models/tournament";
// Services
import { ApiService } from "./../../services/api";
import * as lodash from "lodash";
import { AngularFireDatabase } from "angularfire2/database";
import { DatePipe } from "@angular/common";
import { OAuthService } from "app/services/o-auth";

@Component({
  templateUrl: "./club.subscription.detail.component.html",
})
export class ClubSubscriptionDetailComponent implements OnInit {
  public payments: Array<any>;
  public userId: string;
  public daysLeft: number;
  public imageLoader: boolean = true;
  public club: any;
  constructor(
    private route: ActivatedRoute,
    private elasticService: ElasticService,
    private apiService: ApiService,
    private fireDatabase: AngularFireDatabase,
    private datePipe: DatePipe,
    private oAuthService: OAuthService
  ) {}
  public user;
  ngOnInit() {
    this.user = this.oAuthService.getClub();
    this.userId = this.route.snapshot.params["id"];
    if (!this.userId) {
      return;
    }
    this.fireDatabase.object(`/users/${this.userId}`).subscribe(
      (result) => {
        this.club = result;
        const now = new Date();
        if (result["subscription"]) {
          if (result["subscription"] * 1000 > now.getTime()) {
            this.daysLeft = Math.round(
              Math.abs(
                (result["subscription"] * 1000 - now.getTime()) /
                  (24 * 60 * 60 * 1000)
              )
            );
          } else {
            this.daysLeft = -1;
          }
        } else {
          if (result["trial"]) {
            if (result["trial"] * 1000 > now.getTime()) {
              this.daysLeft = Math.round(
                Math.abs(
                  (result["trial"] * 1000 - now.getTime()) /
                    (24 * 60 * 60 * 1000)
                )
              );
            } else {
              this.daysLeft = -3;
            }
          } else {
            this.daysLeft = -2;
          }
        }
      },
      (error) => {
        console.error(error);
      }
    );
    this.apiService
      .list(`/club-subscriptions/${this.userId}`)
      .then((pay: Array<any>) => {
        // console.log(pay)
        this.payments = pay;
        this.imageLoader = false;
      });
  }
}
